import React from "react"
import SEO from "../components/common/SEO"

export default function TermsConditions() {
  return (
    <>
      <SEO
        title="Conditions Générales d'Utilisation | Centre Spa Land Saphir Palace"
        description="Conditions générales d'utilisation du site web du Centre Spa Land Saphir Palace."
        url="https://www.yourdomain.com/conditions-generales"
      />

      <main className="bg-[#f9f6f1] py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
            <h1 className="text-4xl font-bold text-[#111111] mb-8">
              Conditions Générales d'Utilisation
            </h1>

            <p className="text-gray-600 mb-8">
              Dernière mise à jour : Juin 2026
            </p>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  1. Objet
                </h2>

                <p>
                  Les présentes conditions générales régissent l'accès et
                  l'utilisation du site internet du Centre Spa Land Saphir
                  Palace. En naviguant sur ce site, vous acceptez les
                  présentes conditions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  2. Informations et Services
                </h2>

                <p>
                  Le site présente les prestations, soins, installations et
                  informations relatives au Centre Spa Land Saphir Palace.
                  Les informations affichées sont fournies à titre indicatif
                  et peuvent être modifiées à tout moment.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  3. Réservations
                </h2>

                <p>
                  Les demandes de réservation effectuées via le formulaire
                  de contact ou WhatsApp ne constituent pas une confirmation
                  définitive. Toute réservation reste soumise à validation
                  selon les disponibilités du centre.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  4. Tarifs
                </h2>

                <p>
                  Les tarifs affichés sur le site sont susceptibles d'être
                  modifiés sans préavis. Le prix confirmé au moment de la
                  réservation fait foi.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  5. Responsabilité
                </h2>

                <p>
                  Le Centre Spa Land Saphir Palace s'efforce de fournir des
                  informations exactes et à jour. Toutefois, aucune garantie
                  n'est donnée quant à l'exactitude, l'exhaustivité ou
                  l'actualité permanente des informations publiées.
                </p>

                <p className="mt-3">
                  Le centre ne saurait être tenu responsable des dommages
                  résultant de l'utilisation du site ou de l'impossibilité
                  temporaire d'y accéder.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  6. Propriété Intellectuelle
                </h2>

                <p>
                  L'ensemble du contenu du site (textes, images, logos,
                  éléments graphiques et design) est protégé par les lois
                  relatives à la propriété intellectuelle. Toute reproduction
                  ou utilisation non autorisée est interdite.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  7. Liens Externes
                </h2>

                <p>
                  Le site peut contenir des liens vers des services tiers,
                  notamment Google Maps, WhatsApp ou d'autres plateformes.
                  Le Centre Spa Land Saphir Palace n'est pas responsable du
                  contenu ou des pratiques de ces sites externes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  8. Protection des Données
                </h2>

                <p>
                  L'utilisation des données personnelles est régie par notre
                  Politique de Confidentialité, disponible sur ce site.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  9. Modifications
                </h2>

                <p>
                  Le Centre Spa Land Saphir Palace se réserve le droit de
                  modifier les présentes conditions à tout moment. Les
                  modifications prennent effet dès leur publication sur le
                  site.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">
                  10. Contact
                </h2>

                <p>
                  Pour toute question concernant ces conditions générales,
                  veuillez nous contacter via notre formulaire de contact ou
                  par téléphone.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}